export const getFeaturedArticlesRequest = '/articles/featured';
export const getFeaturedArticleByIdRequest = (featuredArticleId: number) => `/articles/featured/${featuredArticleId}`;
export const createFeaturedArticleRequest = '/articles/featured';
export const updateFeaturedArticleRequest = (featuredArticleId: number) => `/articles/featured/${featuredArticleId}`;
export const sendFeaturedArticleNotification = (featuredArticleId: number) => `articles/featured/${featuredArticleId}/notification`;
